import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarContactosExcel`, method: 'POST', body: value, token: token})
}
